// src/pages/Exhibitions.js 
// (Assuming this file contains your Exhibitions component)

import React from "react";
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'
import NotificationBar from '../../CommonComponent/Notification/NotificationBar'
import Footer from '../../CommonComponent/Footer/footer'

// Page Component
import Exhibitions_Content from "./PageComponent/Exhibitions_Content";

const Exhibitions = () => {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Exhibitions | Marvel Blinds</title>
                <meta
                    name="description"
                    // ⚠️ IMPORTANT: The original value was null. 
                    // Fill this with 150-160 characters of relevant content for SEO.
                    content="" 
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/exhibitions/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Exhibitions" />
                <meta
                    property="og:description"
                    // ⚠️ IMPORTANT: The original value was null. 
                    // Fill this with relevant content for social sharing previews.
                    content=""
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/exhibitions/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <Navbar />
            <NotificationBar />
            <Exhibitions_Content />
            <Footer />
        </>
    );
}

export default Exhibitions;